import { useCallback, useRef } from "react";

export function useTripleClick({ delay = 500, onTripleClick } = {}) {
  const clickCount = useRef(0);
  const clickTimer = useRef(null);
  const lastClickTime = useRef(0);

  const handleClick = useCallback(
    (event) => {
      const now = Date.now();
      if (now - lastClickTime.current > delay) {
        clickCount.current = 0;
      }

      clickCount.current += 1;
      lastClickTime.current = now;

      if (clickTimer.current) {
        clearTimeout(clickTimer.current);
      }

      clickTimer.current = setTimeout(() => {
        if (clickCount.current === 3 && onTripleClick) {
          onTripleClick(event);
        }
        clickCount.current = 0;
      }, delay);
    },
    [delay, onTripleClick]
  );

  const reset = useCallback(() => {
    clickCount.current = 0;
    if (clickTimer.current) {
      clearTimeout(clickTimer.current);
      clickTimer.current = null;
    }
    lastClickTime.current = 0;
  }, []);

  return { handleClick, reset };
}
